/* unplugin-vue-components disabled */import { render } from "./FileItem.vue?vue&type=template&id=b280d024"
import script from "./FileItem.vue?vue&type=script&lang=js"
export * from "./FileItem.vue?vue&type=script&lang=js"

import "./FileItem.vue?vue&type=style&index=0&id=b280d024&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__